import AsyncLayoutFactory from '@/Factories/AsyncLayoutFactory';
import ComponentManager from '@/Management/ComponentManager';
import LayoutRenderer from '@/Utility/LayoutRenderer';

export default class NoneLayoutFactory extends AsyncLayoutFactory {
    private jQueryControl: JQuery;
    private LayoutRenderer = ComponentManager.getUtility<typeof LayoutRenderer>('LayoutRenderer');

    public async getElementAsync(): Promise<JQuery> {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        this.jQueryControl = await new Promise<JQuery>(resolve => {
            window.setTimeout(() => {
                if (this.isDisposed)
                    return;

                const $layout = this.LayoutRenderer.renderNoneLayout(this.tuples, this.context.labelColumnWidth);
                resolve($layout);
            });
        });
        return this.jQueryControl;
    }
}

ComponentManager.setFactory('NoneLayout', NoneLayoutFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');